import axios from '../../helpers/axios-setup';

export const getSourceProductByAppId = (applicationId: number) =>
  axios.get(`/derivatives/product-models/${applicationId}`);

export const getSourceProductByAndCompanyId = (appId: number, behalfCompany: number) =>
  axios.get(`/derivatives/product-models/${appId}/${behalfCompany}`);
